import React from "react";
import Confirmation from "../../components/Confirmation";
import { API, fileUpload } from "../../config";

const ApproveModal = ({
  toggleApproveModal,
  setShowApprove,
  showApprove,
  fetchData,
  type,
  id,
  setLoading,
}) => {
  const handleApprove = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("approved", 1);
      formData.append("_method", "put");
      await fileUpload(
        `${
          type === "incident"
            ? API.INCIDENT_DETAILS
            : type === "risk_assessment"
            ? API.GET_RISK_ASSESSMENT
            : type === "policy"
            ? API.GET_POLICIES
            : API.INCIDENT_DETAILS
        }/${id}`,
        formData
      );
      setLoading(false);
      fetchData();
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Confirmation
      title={"Approve"}
      open={showApprove}
      setOpen={setShowApprove}
      toggleShow={() => {
        toggleApproveModal();
      }}
      className="sm:max-w-1/2"
      message={`Are you sure you want to approve ${type}?`}
      okAction={async () => {
        handleApprove();
        toggleApproveModal();
      }}
      cancelAction={() => {
        setShowApprove(!showApprove);
      }}
    />
  );
};

export default ApproveModal;
